module.exports = __webpack_public_path__ + "static/img/workflow.b955b6cf.png";